<template>
    <BottomSheet ref="bts" v-model="bottomSheet">
        <div class="bg-white rounded-2xl px-8 py-7 flex flex-col items-center shadow-lg relative">
            <div class="absolute top-0 -mt-10">
                <img src="@/assets/icon/dialog/success.svg" alt="success" class="w-20 h-auto" />
            </div>
            <div class="pt-7">
                <div class="text-18 text-blue-1 uppercase text-center">{{ title }}</div>
                <div class="text-18 text-blue-1 text-center">{{ message }}</div>
            </div>
            <div class="w-full flex pt-5">
                <div class="flex flex-col gap-4 mx-auto btn-content">
                    <VBtn blocked large variant="primary" @click="clickOk('add')">{{ btnOk }}</VBtn>
                    <VBtn blocked large variant="outline" @click="clickOk('apply')">{{ btnApply }}</VBtn>
                </div>
            </div>
        </div>
        <Footer :hasPoweredBy="false" />
    </BottomSheet>
</template>
<script>
import VBtn from "@/components/Button/VBtn.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import BottomSheet from "@/components/Dialog/BottomSheet.vue"

import LocaleMixin from "@/mixin/LocaleMixin";
import Utility from "@/helper/Utility";

export default {
    name: 'SuccessfulModal',
    components: {
        VBtn,
        Footer,
        BottomSheet
    },
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    emits: [],
    data: function () {
        return {
            bottomSheet: false,
            title: '',
            message: '',
            btnOk: '',
            btnApply: '',
            busModal: null,
        }
    },
    computed: {
        isMsgEmpty: function () {
            return Utility.isEmptyStr(this.message)
        },
        isTitleEmpty: function () {
            return Utility.isEmptyStr(this.title)
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    beforeUnmount: function () {
        this.busModal.off('show');
        this.busModal.off('hide');
    },
    methods: {
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnApply = config.btnApply;
            if (Utility.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }


            this.$refs.bts.show()
        },
        hide: function () {
            this.$refs.bts.hide()
        },
        clickOk: function (type) {
            this.hide();
            this.controller.sendCallbackOk(type);
        },
        onClose: function () {
            this.controller.sendCallbackClose();
        }
    }
}
</script> 
<style lang="scss" scoped>
.btn-content {
    width: 100%;
    max-width: 300px;
}
</style>